import { useEffect, useState } from "react";
import ExpertDataService from "../services/Expert";
import { useNavigate } from "react-router-dom";
import { SingleExpertRow } from "../components/List/SingleExpertRow";
import { FormControl, FormLabel, Switch, useToast } from "@chakra-ui/react";

export const ExpertList = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();
  const [list, setList] = useState<any>();

  const [isSwitchOn, setIsSwitchOn] = useState(true);

  const isNgodelete = (isdelete: true) => {
    fetchData();
  };

  const handleSwitchChange = (event: any) => {
    setIsSwitchOn(event.target.checked);
  };

  const fetchData = async () => {
    setIsLoading(true);
    ExpertDataService.getExperts(token, !isSwitchOn)
      .then((res: any) => {
        setList(res.data);
        setIsLoading(false);
      })
      .catch((error: any) => {
        setIsLoading(false);
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };
  const syncData = () => {
    ExpertDataService.migrateExpertsData()
      .then((res) => {
        toast({
          position: "top",
          title: "Migration Successful",
          description: res.data,
          status: "success",
          duration: 500,
          isClosable: true,
        });
      })
      .catch((error) => {
        console.log(error);
        toast({
          position: "top",
          title: "Migration Failed!",
          description: error.message,
          status: "error",
          duration: 500,
          isClosable: true,
        });
      });
  };

  const [googleSyncStatuses, setGoogleSyncStatuses] = useState<any[]>([]);

  const getSyncStatuses = async () => {
    const results = [];

    for (const expert of list) {
      const google_info = expert.data.google_info;
      const is_hidden = expert.data.is_hidden;
      const is_archived = expert.data.is_archived;
      const personal_email_id = expert.data.personal_email_id;

      if (google_info?.email && !is_hidden && !is_archived) {
        try {
          await ExpertDataService.getGoogleCalendarEvents(personal_email_id);
          setGoogleSyncStatuses((prev: any) => [
            ...prev,
            { id: expert._id, synced: true },
          ]);
          // results.push({ id: expert._id, synced: true });
        } catch (error) {
          console.error(
            "Failed to get Google events for",
            google_info.email,
            error
          );
          setGoogleSyncStatuses((prev: any) => [
            ...prev,
            { id: expert._id, synced: null },
          ]);
          // results.push({ id: expert._id, synced: false });
        }
      } else {
        setGoogleSyncStatuses((prev: any) => [
          ...prev,
          { id: expert._id, synced: null },
        ]);
        // results.push({ id: expert._id, synced: null });
      }
    }
    // setGoogleSyncStatuses(results);
  };

  useEffect(() => {
    if (list?.length) {
      getSyncStatuses();
    }
  }, [list]);

  useEffect(() => {
    fetchData();
  }, [isSwitchOn]);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Experts - App Experts</div>
      <div className=" p-4">
        {/* top section */}
        <div className="top_section_container">
          <div className="expert_container_item expert_list_button ">
            <FormControl display="flex" alignItems="center">
              <FormLabel>Hide archived experts</FormLabel>
              <Switch
                id="email-alerts"
                isChecked={isSwitchOn}
                onChange={handleSwitchChange}
              />
            </FormControl>
            <div className="btn-group" role="group">
              <button
                type="button"
                style={{ width: "150px" }}
                className="btn action-btn"
                onClick={() => navigate("/experts/add")}
              >
                Add New Expert
              </button>
            </div>

            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate("/experts/timing")}
              >
                Timing
              </button>
            </div>
          </div>
        </div>
        {/* <div className="row m-0 justify-content-between align-items-center">
          <div className="col-sm-6 p-lg-0">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate("/app-experts/add")}
              >
                Add
              </button>
            </div>
          </div>
          <div className="col-sm- p-lg-0">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={syncData}
              >
                Sync Expert Data
              </button>
            </div>
          </div>
        </div> */}

        {/* Main secttion */}
        <div className="main-section" style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>Edit</th>
                <th>Hidden</th>
                <th>Allow Registration</th>
                <th>Full Name</th>
                <th>Whatsapp Number</th>
                <th>Personal Email</th>
                <th>Role</th>
                <th>View</th>
                <th>Action</th>
                <th>Archive Expert</th>
                <th>Sync Calendar</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleExpertRow
                    key={el._id}
                    props={el.data}
                    id={el._id}
                    func={isNgodelete}
                    calendarSyncStatuses={googleSyncStatuses}
                  />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
